/**
 * layouts/index.js
 *
 * Automatically included in `./src/main.js`
 */

import DefaultLayout from '@/layouts/DefaultLayout.vue'

export function registerLayouts (app) {
  app
    .component('DefaultLayout', DefaultLayout)
}
